import makeStyles from '@mui/styles/makeStyles';

const styles = (viewMode: boolean) =>
  makeStyles(() => ({
    container: {
      position: "relative",
      minHeight: "calc(100vh - 300px)",
      paddingBottom: "40px",
    },
    title: {
      fontSize: "20px",
      color: "#465869",
      fontWeight: 700,
      lineHeight: "24px",
      marginBottom: "10px",
    },
    date: {
      color: "#465869",
      fontSize: "17px",
      fontWeight: 700,
    },
    buttons: {
      position: "absolute",
      bottom: 0,
      right: 0,
    },
    titleItem: {
      color: "#465869",
      fontWeight: "bold",
      fontSize: "16px",
    },
    subTitle: {
      fontSize: "13px",
      color: "#465869",
      fontWeight: "bold",
      marginLeft: "10px",
    },
    gridContainer: {
      marginTop: "5px",
    },
    buttonCancel: {
      background: "#79818F",
      marginRight: "15px",
      color: "#FFFFFF",
    },
    titleTimeline: {
      fontWeight: "normal",
      fontSize: "12px",
      color: "#465869",
    },
    subTitleTimeline: {
      fontWeight: "normal",
      color: "#93A9BD",
    },
    icon: {
      fontSize: "18px",
    },
    videoSurveyWrapper: {
      padding: 12,
      position: "relative",
      minHeight: viewMode ? "" : "calc(100vh - 300px)",
    },
    separator: {
      borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
      paddingBottom: "10px",
      marginBottom: "10px",
    },
    mb32: {
      marginBottom: "32px",
    },
  }));

export default styles;
